export enum PowerSupplyAssetType {
  FuelTank = 'fueltank',
  Generator = 'Generator',
  Trailer = 'Trailer'
}
